import React, { memo } from 'react'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import classNames from 'classnames'
import { makeStyles } from '@material-ui/styles'

import styles from './styles'
import { capitalize } from 'utils'
import { IBadgeProps, IBadgeContentProps, EEntity } from 'models'
import { EntityLogo } from 'components'
import { StoreValue } from 'store'

const useStyles = makeStyles(styles)

const BadgeContent: React.FunctionComponent<IBadgeContentProps> = memo(
	({ row, children }) => (row ? <div>{children}</div> : <>{children}</>),
)

const Badge: React.FunctionComponent<IBadgeProps> = props => {
	const {
		// id,
		extraInfoClasses,
		extraAvatarClasses,
		extraClasses,
		currentPositionClasses,
		name,
		title,
		fullView,
		description,
		company,
		publicCompany,
		team,
		type,
		avatarOnly,
		onClick,
		user,
		canEdit,
		storeUserId,
		storeUserIg,
		showUploadCrop,
		// disabledEdit = false,
	} = props
	const row = false
	const classes = useStyles()

	return (
		<Paper
			className={classNames([
				classes.container,
				extraClasses,
				{ [classes.fullView]: fullView, [classes.fullWidth]: row },
			])}
			style={{
				paddingRight: avatarOnly ? 4 : undefined,
				paddingTop: avatarOnly ? 3 : undefined,
			}}
			elevation={1}
			onClick={onClick || undefined}
		>
			<Grid container justifyContent="flex-start" wrap="nowrap">
				<EntityLogo
					alt={title || name + ' logo'}
					type={type}
					extraAvatarClasses={extraAvatarClasses}
					fullView={fullView}
					company={company}
					publicCompany={publicCompany}
					team={team}
					user={user}
					disabledEdit={
						!storeUserIg && storeUserId !== company?.id && !canEdit
					}
					showUploadCrop={showUploadCrop}
				/>
				{!avatarOnly && (
					<Grid
						container
						justifyContent="space-evenly"
						direction="column"
						className={classNames([
							classes.info,
							{ [classes.row]: row },
							extraInfoClasses,
						])}
					>
						<BadgeContent row={row}>
							<div
								className={classNames(
									classes.name,
									classes.ellipsis,
								)}
							>
								{title}
							</div>
							{type === EEntity.person && fullView && (
								<div
									className={classNames(
										classes.currentPosition,
										classes.ellipsis,
									)}
								>
									{title}
								</div>
							)}
						</BadgeContent>
						{!company && (
							<div
								className={classNames(
									classes.role,
									classes.ellipsis,
									{ [classes.autoWidth]: row },
									currentPositionClasses || '',
								)}
							>
								{!team &&
									(publicCompany?.industry || description)}
								{/* todo there is part of the worksAt to be solved */}
								{fullView &&
									user &&
									user.profileCollection &&
									user.profileCollection.edges?.[0].node
										.worksAt &&
									user.profileCollection.edges?.[0].node
										.worksAt.company && (
										<div className={classes.worsAtLabel}>
											Works at
										</div>
									)}
								{(fullView &&
									user &&
									user.profileCollection &&
									user.profileCollection.edges?.[0].node
										.worksAt &&
									user.profileCollection.edges?.[0].node
										.worksAt.company && (
										<div
											className={
												classes.currentPositionItem
											}
										>
											{
												user.profileCollection
													.edges?.[0].node.worksAt
													.company
											}
										</div>
									)) ||
									undefined}
								{fullView && team && (
									<div
										className={classes.currentPositionItem}
									>
										{' '}
										- {team}
									</div>
								)}
							</div>
						)}
						{company && (
							<div
								className={classNames(
									classes.role,
									classes.ellipsis,
									{ [classes.autoWidth]: row },
									currentPositionClasses || '',
								)}
							>
								{description && capitalize(description)}
							</div>
						)}
						{team && (
							<div
								className={classNames(
									classes.role,
									classes.ellipsis,
									{ [classes.autoWidth]: row },
									currentPositionClasses || '',
								)}
							>
								{
									// TODO: check the next line. Should I use description or department.
								}
								{description && capitalize(description)}
							</div>
						)}
					</Grid>
				)}
			</Grid>
		</Paper>
	)
}

export default memo((props: IBadgeProps) => (
	<StoreValue keys={['user.id|storeUserId', 'user._ig|storeUserIg']}>
		<Badge {...props} />
	</StoreValue>
))
